module.exports = "0xFe575c03caF2b54Cdad1F57b2D1C51E4aC0dE4e8"


// WEBPACK FOOTER //
// ./src/contracts/SlammerTime.3.address.js